import styled from '@emotion/styled';
import { typography, White } from './Styles';

const Card = styled.div`
  ${typography}
  display: flex;
  flex-direction: column;
  background: ${White};
`;

export default Card;
